import React from "react";
import { SectionHeading } from "./CampaignHero";
import { GovernanceIcon } from "./BrandIcons";
import ecosystems from "../lib/industry-ecosystems.json";
import { PHOTO_VERSION } from "../lib/images";
import { MobileDetails } from "./mobile/MobileDetails";
import "../industry-ecosystem.css";

export const IndustryEcosystem = ({ slug }) => {
  const ecosystem = ecosystems[slug];
  if (!ecosystem) return null;
  return <section id="ecosystem" className="campaign-section industry-ecosystem" data-testid="industry-ecosystem">
    <div className="campaign-container">
      <SectionHeading id="industry-ecosystem" eyebrow="Helios across your ecosystem" title={ecosystem.title} body={ecosystem.intro} />
      <div className="ecosystem-authority" data-testid="ecosystem-authority">
        <GovernanceIcon size={30} />
        <div><span className="campaign-micro">Decision authority</span><h3 data-testid="ecosystem-authority-role">{ecosystem.authority.role}</h3><p data-testid="ecosystem-authority-scope">{ecosystem.authority.scope}</p></div>
        <div className="ecosystem-support"><span className="campaign-micro">Helios supports</span><p data-testid="ecosystem-authority-support">{ecosystem.authority.support}</p></div>
      </div>
    </div>
    {ecosystem.scenes.map((scene, index) => <article key={scene.id} className={`ecosystem-story ${index % 2 ? "ecosystem-story-reverse" : ""}`} data-testid={`ecosystem-story-${scene.id}`}>
      <div className="campaign-container ecosystem-story-grid">
        <figure className="ecosystem-figure">
          <picture><source media="(max-width: 767px)" srcSet={`/industry-scenes/${scene.id}-mobile.webp?v=${PHOTO_VERSION}`} /><img data-testid={`ecosystem-image-${scene.id}`} src={`/industry-scenes/${scene.id}.webp?v=${PHOTO_VERSION}`} alt={`${scene.alt}. Illustrative generated scene.`} width="1264" height="848" loading="lazy" decoding="async" /></picture>
          <figcaption data-testid={`ecosystem-photo-role-${scene.id}`}>{scene.role}</figcaption>
        </figure>
        <div className="ecosystem-story-copy">
          <span className="campaign-micro" data-testid={`ecosystem-channel-${scene.id}`}>{scene.channel}</span>
          <h3 data-testid={`ecosystem-title-${scene.id}`}>{scene.title}</h3>
          <p data-testid={`ecosystem-body-${scene.id}`}>{scene.body}</p>
          <MobileDetails id={`ecosystem-details-${scene.id}`} label="Scope, review & evidence"><dl>
            <div><dt>Appropriate scope</dt><dd data-testid={`ecosystem-scope-${scene.id}`}>{scene.scope}</dd></div>
            <div><dt>Review & escalation</dt><dd data-testid={`ecosystem-escalation-${scene.id}`}>{scene.escalation}</dd></div>
            <div><dt>Evidence returned</dt><dd data-testid={`ecosystem-feedback-${scene.id}`}>{scene.feedback}</dd></div>
          </dl></MobileDetails>
        </div>
      </div>
    </article>)}
    <div className="campaign-container ecosystem-footnote"><p className="campaign-small" data-testid="ecosystem-illustration-note">Illustrative ecosystem and interfaces, not a live deployment. Roles, integrations and approval limits are defined with each organization.</p></div>
  </section>;
};